module.exports = __webpack_public_path__ + "img/bottom-right-corner.772bba05.svg";